module.exports = __webpack_public_path__ + "img/collection-diamondJewelryRosegold@2x.93c3714.jpg";